// Forstkern Theme v4

// NAV
function toggleMobileMenu(){
  var m = document.getElementById('nav-mobile-menu');
  if(m) m.classList.toggle('open');
}
function closeMobileMenu(){
  var m = document.getElementById('nav-mobile-menu');
  if(m) m.classList.remove('open');
}

function scrollToEl(id){
  var el = document.getElementById(id);
  if(el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

// HAUPT-TABS
function mainTab(id, btn){
  document.querySelectorAll('.mpane').forEach(function(p){ p.classList.remove('on'); });
  document.querySelectorAll('.mtab').forEach(function(b){ b.classList.remove('on'); });
  var pane = document.getElementById('pane-' + id);
  if(pane) pane.classList.add('on');
  if(btn) btn.classList.add('on');
}

// ── VERFÜGBARKEIT / LAGERBESTAND ──────────────────────────────────
// window.FK_STOCK wird inline im angebot.liquid gesetzt: { hh_25:N, hh_33:N, bu_25:N, bu_33:N }
function fkStock(pid, len){
  var s = window.FK_STOCK || {};
  var v = s[pid + '_' + len];
  return (typeof v === 'number' && !isNaN(v)) ? v : 0;
}

var currentLen = { hh: '25', bu: '25' };

function updateStockHint(pid){
  var hint = document.getElementById(pid + '-stock-hint');
  var max = fkStock(pid, currentLen[pid]);
  if(hint) hint.textContent = 'Noch ' + max + ' SRM verfügbar';
  var plus = document.getElementById(pid + '-qty-plus');
  if(plus) plus.disabled = qtys[pid] >= max;
}

// PRODUKT LÄNGE
function selLen(btn, pid){
  if(btn.disabled) return;
  document.querySelectorAll('.lbtn[data-pid="' + pid + '"]').forEach(function(b){ b.classList.remove('on'); });
  btn.classList.add('on');
  var len = btn.getAttribute('data-len');
  if(len) currentLen[pid] = len;
  var max = fkStock(pid, currentLen[pid]);
  if(qtys[pid] > max) qtys[pid] = Math.max(max > 0 ? 1 : 0, max);
  if(qtys[pid] < 1 && max > 0) qtys[pid] = 1;
  var el = document.getElementById(pid + '-qty');
  if(el) el.textContent = qtys[pid];
  updateStockHint(pid);
}

// MENGE
var qtys = { hh: 1, bu: 1 };
function adjQty(pid, d){
  var max = fkStock(pid, currentLen[pid]);
  var next = qtys[pid] + d;
  if(next < 1) next = 1;
  if(max > 0 && next > max) next = max;
  qtys[pid] = next;
  var el = document.getElementById(pid + '-qty');
  if(el) el.textContent = qtys[pid];
  updateStockHint(pid);
}

// ── ANFRAGE-LIMIT: max 7 pro 30 Minuten ──────────────────────────
var LIMIT_MAX = 7;
var LIMIT_MS  = 30 * 60 * 1000;
var STORE_KEY = 'fk_anfragen';

function getLimitData(){
  try { var r = localStorage.getItem(STORE_KEY); return r ? JSON.parse(r) : []; } catch(e){ return []; }
}
function saveLimitData(arr){
  try { localStorage.setItem(STORE_KEY, JSON.stringify(arr)); } catch(e){}
}
function getRecentCount(){
  var now = Date.now();
  var arr = getLimitData().filter(function(t){ return (now - t) < LIMIT_MS; });
  saveLimitData(arr); return arr.length;
}
function limitResetsAt(){
  var now = Date.now();
  var arr = getLimitData().filter(function(t){ return (now - t) < LIMIT_MS; });
  if(!arr.length) return null;
  return new Date(Math.min.apply(null, arr) + LIMIT_MS);
}
function recordAnfrage(){
  var arr = getLimitData(); arr.push(Date.now()); saveLimitData(arr);
}
function formatTime(d){ return d.getHours() + ':' + (d.getMinutes()<10?'0':'') + d.getMinutes() + ' Uhr'; }
function checkLimit(){
  if(getRecentCount() >= LIMIT_MAX){
    var r = limitResetsAt();
    alert('Sie haben in den letzten 30 Minuten bereits ' + LIMIT_MAX + ' Anfragen gesendet.\n' +
      (r ? 'Bitte warten Sie bis ' + formatTime(r) + '.\n' : '') +
      'Bei dringenden Anfragen rufen Sie uns direkt an.');
    return false;
  }
  return true;
}

// ── FORMSPREE ENDPOINT ────────────────────────────────────────────
var FORMSPREE = 'https://formspree.io/f/xzdwavpa';

function postToFormspree(data, onSuccess, onError){
  fetch(FORMSPREE, {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  .then(function(r){
    if(r.ok){ onSuccess(); } else { onError(); }
  })
  .catch(function(){ onError(); });
}

// ── WARENKORB ────────────────────────────────────────────────────
var cart = [];
var products = {
  hh: { name: 'Hartholz Mix', price: 105, icon: '🪵' },
  bu: { name: 'Buche', price: 120, icon: '🌳' }
};

function addToCart(pid){
  var len = currentLen[pid] + ' cm';
  var max = fkStock(pid, currentLen[pid]);
  if(max <= 0){
    alert('Diese Länge ist leider ausverkauft.');
    return;
  }
  var qty = Math.min(qtys[pid], max);
  var p = products[pid], key = pid + '_' + len;
  var existing = cart.find(function(c){ return c.key === key; });
  var already = existing ? existing.qty : 0;
  if(already + qty > max){
    qty = Math.max(0, max - already);
    if(qty <= 0){
      alert('Von dieser Länge sind bereits alle verfügbaren ' + max + ' SRM im Warenkorb.');
      return;
    }
  }
  if(existing){ existing.qty += qty; }
  else { cart.push({ key:key, pid:pid, name:p.name, len:len, price:p.price, qty:qty, icon:p.icon }); }
  renderCart();
  var btn = document.getElementById('add-btn-' + pid);
  if(btn){
    var orig = btn.textContent;
    btn.textContent = '✅ Hinzugefügt!'; btn.style.background = '#3d5c30';
    setTimeout(function(){ btn.textContent = orig; btn.style.background = ''; }, 1500);
  }
  scrollToEl('cart-section');
  var ob = document.getElementById('order-box');
  if(ob) ob.classList.remove('on');
}

function renderCart(){
  var versand = pickupMode === 'abholung'
    ? 'SELBSTABHOLUNG in Waldbach (kostenlos)'
    : 'LIEFERUNG nach Hause (0,50 EUR/km Hin & Rueck)';
  var body = document.getElementById('cart-body');
  var foot = document.getElementById('cart-foot');
  var cnt  = document.getElementById('cart-count');
  var tp   = document.getElementById('cart-total-price');
  if(!body) return;
  if(!cart.length){
    body.innerHTML = '<div class="cart-empty"><span class="cart-empty-icon">🛒</span>Noch leer – wählen Sie oben Sorte, Länge und Menge.</div>';
    if(foot) foot.style.display = 'none';
    if(cnt)  cnt.textContent = '0';
    return;
  }
  var total = 0, totalQty = 0, html = '';
  cart.forEach(function(item, i){
    var sub = item.price * item.qty; total += sub; totalQty += item.qty;
    html += '<div class="cart-item">';
    html += '<span class="ci-ico">' + item.icon + '</span>';
    html += '<div class="ci-info"><div class="ci-name">' + item.name + '</div><div class="ci-detail">' + item.len + ' &nbsp;&middot;&nbsp; ' + item.price + ' &euro;/SRM</div></div>';
    html += '<div class="ci-qc"><button onclick="cartAdj(' + i + ',-1)">&minus;</button><span>' + item.qty + '</span><button onclick="cartAdj(' + i + ',1)">+</button></div>';
    html += '<div class="ci-price">' + sub.toFixed(2) + ' &euro;</div>';
    html += '<button class="ci-del" onclick="cartDel(' + i + ')" aria-label="Entfernen">&times;</button>';
    html += '</div>';
  });
  body.innerHTML = html;
  if(foot) foot.style.display = 'block';
  if(tp)   tp.textContent = total.toFixed(2) + ' \u20ac';
  if(cnt)  cnt.textContent = totalQty;
    // 2-ANFAHRTEN-HINWEIS: bei Lieferung und >5 SRM
      var warn = document.getElementById('cart-zwei-anfahrten');
        if(!warn){ warn = document.createElement('div'); warn.id='cart-zwei-anfahrten'; warn.style.cssText='background:#c0392b;color:#fff;padding:12px 16px;border-radius:8px;margin-top:12px;font-weight:600;font-size:0.95em;line-height:1.5;display:none;'; foot.appendChild(warn); }
          if(pickupMode !== 'abholung' && totalQty > 5){
              warn.style.display = 'block';
                  warn.innerHTML = '&#9888; <strong>Hinweis: Mehr als 5 SRM bestellt!</strong><br>Bei dieser Menge sind <strong>2 Anfahrten</strong> notwendig. Die Lieferkosten werden daher <strong>verdoppelt</strong>.';
                      var calcTrips = document.getElementById('calc-trips');
                          if(calcTrips) calcTrips.value = '2';
                            } else {
                                warn.style.display = 'none';
                                    var calcTrips = document.getElementById('calc-trips');
                                        if(calcTrips && calcTrips.value === '2') calcTrips.value = '1';
                                          }
}

function cartAdj(i, d){
  var item = cart[i];
  var max = fkStock(item.pid, item.len.replace(' cm',''));
  var next = item.qty + d;
  if(next < 1) next = 1;
  if(max > 0 && next > max) next = max;
  item.qty = next;
  renderCart();
}
function cartDel(i){
  cart.splice(i, 1); renderCart();
  var ob = document.getElementById('order-box'); if(ob) ob.classList.remove('on');
}
function goToCart(){ scrollToEl('cart-section'); }


// ── ABHOLUNG / LIEFERUNG ─────────────────────────────────────────
var pickupMode = 'lieferung'; // 'lieferung' oder 'abholung'

function setPickup(mode){
  pickupMode = mode;
  var bl = document.getElementById('pbtn-lieferung');
  var ba = document.getElementById('pbtn-abholung');
  var hl = document.getElementById('hint-lieferung');
  var ha = document.getElementById('hint-abholung');
  var af = document.getElementById('addr-field');
  if(mode === 'abholung'){
    if(bl) bl.classList.remove('on');
    if(ba) ba.classList.add('on');
    if(hl) hl.style.display = 'none';
    if(ha) ha.style.display = 'block';
    if(af){ af.style.display = 'none'; var inp = document.getElementById('o-ad'); if(inp){ inp.value = 'Selbstabholung in Waldbach'; inp.required = false; } }
  } else {
    if(bl) bl.classList.add('on');
    if(ba) ba.classList.remove('on');
    if(hl) hl.style.display = 'block';
    if(ha) ha.style.display = 'none';
    if(af){ af.style.display = 'block'; var inp = document.getElementById('o-ad'); if(inp){ if(inp.value === 'Selbstabholung in Waldbach') inp.value = ''; inp.required = true; } }
  }
}

function showOrder(){
  if(!cart.length) return;
  var box = document.getElementById('order-box');
  if(!box) return;
  box.classList.add('on');
  var total = cart.reduce(function(s,c){ return s + c.price*c.qty; }, 0);
  var html = '<div class="os-tag">Bestellübersicht</div>';
  cart.forEach(function(c){
    html += '<div class="os-row"><span>' + c.icon + ' ' + c.name + ' (' + c.len + ') &times; ' + c.qty + ' SRM</span><span>' + (c.price*c.qty).toFixed(2) + ' &euro;</span></div>';
  });
  html += '<div class="os-total"><span>Produktsumme</span><span>' + total.toFixed(2) + ' &euro;</span></div>';
  html += '<div style="font-size:.71rem;color:var(--tl);margin-top:.3rem">+ Lieferkosten: 0,50 &euro;/km (werden auf die Rechnung gesetzt)</div>';
  var sumBox = document.getElementById('order-summary');
  if(sumBox) sumBox.innerHTML = html;
  box.scrollIntoView({ behavior: 'smooth' });
}

// ── BESTELLUNG ABSENDEN (Formspree) ──────────────────────────────
function sendOrder(){
  if(!checkLimit()) return;

  var fn = (document.getElementById('o-fn')||{}).value||'';
  var ln = (document.getElementById('o-ln')||{}).value||'';
  var ph = (document.getElementById('o-ph')||{}).value||'';
  var em = (document.getElementById('o-em')||{}).value||'';
  var ad = (document.getElementById('o-ad')||{}).value||'';
  var no = (document.getElementById('o-no')||{}).value||'';

  if(!fn.trim()||!ln.trim()||!ph.trim()||!ad.trim()){
    alert('Bitte Vorname, Nachname, Telefon und Lieferadresse ausfüllen.');
    return;
  }

  var total = cart.reduce(function(s,c){ return s+c.price*c.qty; }, 0);
  var produkte = cart.map(function(c){
    return c.name + ' (' + c.len + ') x ' + c.qty + ' SRM = ' + (c.price*c.qty).toFixed(2) + ' EUR';
  }).join('\n');

  var btn = document.getElementById('order-submit-btn');
  if(btn){ btn.textContent = '⏳ Wird gesendet…'; btn.disabled = true; }

  postToFormspree({
    _subject: 'Neue Bestellung – ' + fn + ' ' + ln,
    Name: fn + ' ' + ln,
    Telefon: ph,
    'E-Mail': em || '–',
    Lieferadresse: ad,
    Wunschtermin: no || '–',
    Bestellung: produkte,
    Produktsumme: total.toFixed(2) + ' EUR',
    Versandart: (pickupMode === 'abholung' ? 'Selbstabholung in Waldbach' : 'Lieferung nach Hause')
  }, function(){
    // Erfolg
    recordAnfrage();
    var succ = document.getElementById('order-success');
    if(succ) succ.classList.add('on');
    if(btn){ btn.style.display = 'none'; }
    cart = []; renderCart();
    var ob = document.getElementById('order-box');
    if(ob) setTimeout(function(){ ob.classList.remove('on'); }, 4000);
  }, function(){
    // Fehler
    if(btn){ btn.textContent = '✉️ Bestellung absenden'; btn.disabled = false; }
    alert('Fehler beim Senden. Bitte versuchen Sie es nochmal oder rufen Sie uns an.');
  });
}

// ── DIENSTLEISTUNGS-ANFRAGE (Formspree) ──────────────────────────
function sendService(leistung, prefix){
  if(!checkLimit()) return;

  var name = (document.getElementById(prefix+'-name')||{}).value||'';
  var tel  = (document.getElementById(prefix+'-tel') ||{}).value||'';
  var desc = (document.getElementById(prefix+'-desc')||{}).value||'';

  if(!name.trim()||!tel.trim()){
    alert('Bitte Name und Telefonnummer angeben.');
    return;
  }

  var btn = document.getElementById(prefix+'-sendbtn');
  if(btn){ btn.textContent = '⏳ …'; btn.disabled = true; }

  postToFormspree({
    _subject: 'Anfrage ' + leistung + ' – ' + name,
    Leistung: leistung,
    Name: name,
    Telefon: tel,
    Beschreibung: desc || '–'
  }, function(){
    recordAnfrage();
    var ok = document.getElementById(prefix+'-ok');
    if(ok) ok.classList.add('on');
    if(btn){ btn.textContent = 'Senden'; btn.disabled = false; }
    setTimeout(function(){
      var f = document.getElementById('sf-'+prefix);
      if(f) f.classList.remove('on');
      var ok2 = document.getElementById(prefix+'-ok');
      if(ok2) ok2.classList.remove('on');
      if(document.getElementById(prefix+'-name')) document.getElementById(prefix+'-name').value='';
      if(document.getElementById(prefix+'-tel'))  document.getElementById(prefix+'-tel').value='';
      if(document.getElementById(prefix+'-desc')) document.getElementById(prefix+'-desc').value='';
    }, 2500);
  }, function(){
    if(btn){ btn.textContent = 'Senden'; btn.disabled = false; }
    alert('Fehler beim Senden. Bitte versuchen Sie es nochmal.');
  });
}

// Service Forms toggle
function toggleSF(id){
  var f = document.getElementById(id);
  var wasOpen = f && f.classList.contains('on');
  document.querySelectorAll('.sform').forEach(function(x){ x.classList.remove('on'); });
  if(!wasOpen && f) f.classList.add('on');
}

// ── LIEFERRECHNER ────────────────────────────────────────────────
function doCalc(){
  var km    = parseFloat((document.getElementById('calc-km')   ||{}).value||'');
  var trips = parseInt( (document.getElementById('calc-trips')||{}).value||'1')||1;
  var pp    = 0.50;
  if(isNaN(km)||km<=0){ alert('Bitte die ungefähre Entfernung in km eingeben.'); return; }
  var rt=km*2, pTrip=rt*pp, tot=pTrip*trips;
  document.getElementById('r-km').textContent    = Math.round(km) + ' km';
  document.getElementById('r-rt').textContent    = Math.round(rt*trips) + ' km';
  document.getElementById('r-pp').textContent    = pTrip.toFixed(2) + ' \u20ac';
  document.getElementById('r-trips').textContent = trips;
  document.getElementById('r-total').textContent = tot.toFixed(2) + ' \u20ac';
  var res = document.getElementById('calc-res');
  if(res){ res.classList.add('on'); res.scrollIntoView({ behavior:'smooth', block:'nearest' }); }
}

document.addEventListener('DOMContentLoaded', function(){
  var kmEl = document.getElementById('calc-km');
  if(kmEl) kmEl.addEventListener('keypress', function(e){ if(e.key==='Enter') doCalc(); });

  // Verfügbarkeit initial anzeigen (Standardlänge je Sorte aus der Liquid-Vorauswahl übernehmen)
  ['hh','bu'].forEach(function(pid){
    var onBtn = document.querySelector('.lbtn.on[data-pid="' + pid + '"]');
    if(onBtn){
      var len = onBtn.getAttribute('data-len');
      if(len) currentLen[pid] = len;
    }
    updateStockHint(pid);
  });
});
